var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4a3 3 0 013-3h23v40H4a3 3 0 01-3-3V4z",
    fill: "#DADADA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 33,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1h13a2 2 0 012 2v36a2 2 0 01-2 2H26V1z",
    fill: "#EDB9FF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0xIDRDMSAyLjM0MzE1IDIuMzQzMTUgMSA0IDFIMjdWNDFINEMyLjM0MzE1IDQxIDEgMzkuNjU2OSAxIDM4VjRaIiBmaWxsPSIjREFEQURBIi8+CiAgPHJlY3QgeD0iNSIgeT0iNSIgd2lkdGg9IjE4IiBoZWlnaHQ9IjQiIHJ4PSIyIiBmaWxsPSJ3aGl0ZSIvPgogIDxyZWN0IHg9IjUiIHk9IjEyIiB3aWR0aD0iMTgiIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9IndoaXRlIi8+CiAgPHJlY3QgeD0iNSIgeT0iMTkiIHdpZHRoPSIxOCIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0id2hpdGUiLz4KICA8cmVjdCB4PSI1IiB5PSIyNiIgd2lkdGg9IjE4IiBoZWlnaHQ9IjQiIHJ4PSIyIiBmaWxsPSJ3aGl0ZSIvPgogIDxyZWN0IHg9IjUiIHk9IjMzIiB3aWR0aD0iMTgiIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9IndoaXRlIi8+CiAgPHBhdGggZD0iTTI2IDFIMzlDNDAuMTA0NiAxIDQxIDEuODk1NDMgNDEgM1YzOUM0MSA0MC4xMDQ2IDQwLjEwNDYgNDEgMzkgNDFIMjZWMVoiIGZpbGw9IiNFREI5RkYiLz4KPC9zdmc+Cg==";
export { SvgDocked as ReactComponent };